import React, { useState, useEffect } from 'react';
import 'gridjs/dist/theme/mermaid.css';
import { createRoot } from 'react-dom/client';
import axios from '../axios';
import { handleBrowzerBack } from '../BrowzerBack';
import LoadingModal from '../molecules/LoadingModal';
import { Modal, Button } from 'react-bootstrap';
import { overview_step_img, product_summary_link } from '../Const';
import { scrollPageTop } from '../Scroll';
import { jumpUrl } from '../Common';

interface Config {
  disabled_project_detail_status: number[];
}

const ProjectListApplicantImpl: React.FC = () => {
  const [projects, setProjects] = useState([]);
  const [config, setConfig] = useState<Config>({
    disabled_project_detail_status: [],
  });
  const [is_loading, setIsLoading] = useState(false);
  const [modal_show, setModalShow] = useState(false);
  const [modal_message, setModalMessage] = useState('');

  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowzerBack();
    const getProject = async () => {
      try {
        //ローディング画面表示
        setIsLoading(true);
        const response = await axios.get('/mypage/project/applicant');

        setProjects(response.data.reception_list);
        setConfig(response.data.config);
      } catch (error) {
        console.error(error.message);
      } finally {
        //画面トップに遷移
        scrollPageTop();
        //ローディング画面非表示
        setIsLoading(false);
      }
    };
    getProject();
  }, []);

  const images = [
    {
      //TODO degawa 差し替える画像の確認取れ次第変更
      src: overview_step_img,
      grid_system_class: 'col-xl-12 my-3',
    },
  ];
  const stepImageList: JSX.Element[] = [];
  images.map((image, index) => {
    stepImageList.push(
      <div key={index} className={image.grid_system_class}>
        <img src={image.src} className="img-fluid image-size-m" />
      </div>
    );
  });

  /**
   * 案件一覧詳細画面へのハイパーリンクを生成する
   * @param id 受付ID
   * @param reception_cd 案件番号
   * @param status 案件ステータス
   */
  const makeHyperLink = (id: string, reception_cd: string, status: string) => {
    // リンクを非表示にする対象のステータスではない場合はハイパーリンクを生成する
    if (!config.disabled_project_detail_status.includes(Number(status))) {
      return (
        <a
          className="link-text"
          href={`${location.origin}${process.env.MIX_MOCK_URL}/reception/${reception_cd}/${id}`}
          onClick={(event: React.MouseEvent<HTMLAnchorElement>) =>
            handleClickReception(event, id, reception_cd, status)
          }
        >
          {reception_cd}
        </a>
      );
    }
    return reception_cd;
  };

  /**
   * 案件番号のリンクをクリックする
   * @param event イベントオブジェクト
   * @param id 案件ID
   * @param r_cd 案件番号
   * @param status ステータス
   */
  const handleClickReception = (
    event: React.MouseEvent<HTMLAnchorElement>,
    id: string,
    r_cd: string,
    status: string
  ) => {
    event.preventDefault();
    setIsLoading(true);
    checkStatus(id, r_cd, status);
  };

  /**
   * 案件ステータスチェック
   * @param id 案件ID
   * @param r_cd 案件番号
   * @param status ステータス
   */
  const checkStatus = async (id: string, r_cd: string, status: string) => {
    try {
      const response = await axios.post('/api/project/status/check', {
        reception_cd: r_cd,
        status: status,
      });

      if (response.data.result) {
        // 遷移処理
        location.href = `${location.origin}${process.env.MIX_MOCK_URL}/reception/${r_cd}/${id}`;
      } else {
        // エラーメッセージを表示
        setIsLoading(false);
        setModalMessage(response.data.message);
        setModalShow(true);
      }
    } catch (exception) {
      jumpUrl(exception.response.data.url);
      setIsLoading(false);
      setModalMessage('案件ステータスが更新されています。案件を再度選択してください。');
      setModalShow(true);
    }
  };

  /**
   * モーダルを閉じる
   */
  const closeModal = () => {
    setModalShow(false);
    location.reload();
  };

  const projectsList: JSX.Element[] = [];
  // 案件一覧を取得できた場合のみ案件一覧を生成する
  {
    projects.map((project: { [key: string]: string }, index) => {
      projectsList.push(
        <tr key={index}>
          <td className="id">
            {/* スマホ表示時の番号表示 */}
            <span className="no">No.{index + 1}</span>
            {/* 案件番号のリンク */}
            <span className="id-body">
              {makeHyperLink(project.id, project.reception_cd, project.status)}
            </span>
          </td>
          <td className="applicant_date">{project.application_date}</td>
          <td className="role">{project.role_name}</td>
          <td className="status">{project.status_name}</td>
        </tr>
      );
    });
  }
  return (
    <>
      <div className="container">
        <div className="row justify-content-md-center">
          <div className="col-xl-12 my-3">
            ※既にマイページのご登録がお済の方で、まだWEB住宅ローンのお申込みをされていない方は、『WEB住宅ローン申込み』をクリックまたはタッチをして頂き、お申込み操作を行ってください。
            <br />
            ※現在WEB住宅ローンをお申込み中の方は、管理番号をクリックまたはタッチをして頂き、お申込み操作を行ってください。
          </div>
        </div>
        {projectsList.length > 0 && (
          // 案件一覧を取得できた

          <div className="project-list">
            <table>
              <thead>
                <tr>
                  <th>案件番号</th>
                  <th>お申込み日</th>
                  <th>権限</th>
                  <th>状態</th>
                </tr>
              </thead>
              <tbody>{projectsList}</tbody>
            </table>
          </div>
        )}
      </div>
      {/* ローディング画面 */}
      <LoadingModal show={is_loading} />
      {/* エラーメッセージダイアログ */}
      <Modal show={modal_show} onHide={() => {}}>
        <Modal.Body className="dialog-body">{modal_message}</Modal.Body>
        <Modal.Footer>
          <Button variant="main-color" onClick={() => closeModal()}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

const container = document.getElementById('project-list-applicant-impl');
if (container) {
  const root = createRoot(container);
  root.render(<ProjectListApplicantImpl />);
}
